import React, { FC, ReactElement } from "react"

const NotFound: FC = (): ReactElement => {

    return <>
        <div className="position-absolute top-0 start-0 w-100 h-100">
            <div className="text-center position-absolute top-50 start-50 w-100 translate-middle">
                <h1 className="text-2xl font-bold">404 Not Found</h1>
                <p className="text-muted">ページが見つかりません</p>
            </div>
        </div>
    </>
}

export default NotFound